import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { PublicPage, Seo } from "@/components/public/PublicChrome";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("working");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("invalid"); return; }
    api.post("/public/unsubscribe", { token })
      .then(({ data }) => setStatus(data.ok ? "done" : "invalid"))
      .catch(() => setStatus("invalid"));
  }, [params]);

  return (
    <PublicPage>
      <Seo title="Unsubscribe" path="/unsubscribe" description="Manage your Fairview Systems email preferences." />
      <section className="max-w-xl mx-auto px-6 pt-40 pb-32 text-center">
        {status === "done" && (
          <div data-testid="unsub-done">
            <CheckCircle2 className="w-10 h-10 text-[#10B981] mx-auto mb-4" />
            <h1 className="font-heading text-3xl mb-3">You're unsubscribed</h1>
            <p className="text-[#A1A1AA]">You won't receive further marketing emails from Fairview Systems. Essential account emails are unaffected.</p>
          </div>
        )}
        {status === "invalid" && (
          <div data-testid="unsub-invalid">
            <XCircle className="w-10 h-10 text-[#EF4444] mx-auto mb-4" />
            <h1 className="font-heading text-3xl mb-3">Link not valid</h1>
            <p className="text-[#A1A1AA]">This unsubscribe link is invalid or has already been used.</p>
          </div>
        )}
        {status === "working" && <p className="text-[#A1A1AA]" data-testid="unsub-working">Processing…</p>}
        <Link to="/" className="inline-block mt-6 text-[#D4AF37]">Return to Fairview Systems</Link>
      </section>
    </PublicPage>
  );
}
